export default function getProductsSalesSumChartConfig(showAVGofSUM, setShowAVGofSUM, currentData, averageOfSum, itemsPerPage, showmedianOfSUM, medianOfSUM) {
  return {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        // display: true,
        display: false,
        position: "bottom",
        labels: {
          generateLabels: () => {
            return [
              {
                text: "Średnia z sumy",
                fillStyle: "#FF7A00",
                strokeStyle: "#FF7A00",
                lineWidth: 2,
                hidden: !showAVGofSUM,
                index: 0,
              },
            ];
          },
          usePointStyle: true,
          pointStyle: "line",
        },
        onClick: () => setShowAVGofSUM(!showAVGofSUM),
      },
      tooltip: {
        callbacks: {
          title: () => "Sprzedaż (ostatnie 30 dni)",
          label: (context) => {
            const label = context.dataset.label || "";
            const value = context.raw || 0;
            const index = context.dataIndex;
            const product = currentData[index];
            const count = product ? product.SummaryIncomeCount || 0 : 0;
            const formattedValue = new Intl.NumberFormat("pl-PL", {
              style: "currency",
              currency: "PLN",
            }).format(value);
            return `${label} ${currentData[index].ProductFullName}: ${formattedValue} (${count} szt.)`;
          },
        },
      },
      title: {
        display: false,
      },
      annotation: {
        annotations: {
          averageLine: {
            display: showAVGofSUM,
            type: "line",
            xMin: averageOfSum,
            xMax: averageOfSum,
            borderColor: "#FF7A00",
            borderWidth: 4,
            label: {
              display: true,
              content: `  ${new Intl.NumberFormat("pl-PL", {
                style: "currency",
                currency: "PLN",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(averageOfSum)}  `,
              position: "end",
              backgroundColor: "#FF7A00",
              color: "white",
              padding: 2,
            },
          },
          medianLine: {
            type: "line",
            display: showmedianOfSUM,
            xMin: medianOfSUM,
            xMax: medianOfSUM,
            borderColor: "#666A71",
            borderWidth: 4,
            label: {
              display: showmedianOfSUM,
              content: `  ${new Intl.NumberFormat("pl-PL", {
                style: "currency",
                currency: "PLN",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(medianOfSUM)}  `,
              position: "end",
              backgroundColor: "#666A71",
              color: "white",
              padding: 2,
            },
          },
        },
      },
    },
    scales: {
      x: {
        position: "top",
        beginAtZero: true,
        title: {
          display: false,
        },
        ticks: {
          callback: (value) => {
            return new Intl.NumberFormat("pl-PL", {
              style: "currency",
              currency: "PLN",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(value);
          },
        },
        grid: {
          color: "rgba(0, 0, 0, 0.1)",
        },
      },
      y: {
        title: {
          display: true,
        },
        ticks: {
          autoSkip: false,
          maxTicksLimit: itemsPerPage,
          // max: Math.max(...currentData.map(({MachineFullName})=>MachineFullName?.length)) * 1.2
        },
      },
    },

    hover: {
      mode: "nearest",
      intersect: true,
    },
    animation: {
      duration: 0,
    },
  }
}